export const DEPOSIT_ROOT = '/deposit'

export const routes = {
  depositHome: '/',
  manageCards: '/manage-cards',
} as const
